@reference "@glow/tailwind-config/reference.css";

:global(.rdp-root) {
  --rdp-accent-color: var(--color-primary-500);
  /* tailwind gray 100 */
  --rdp-background-color: rgb(245 245 245);
  --rdp-outline: 2px solid var(--color-primary-500);
  --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);
  --rdp-nav_button-height: 1.75rem;
  --rdp-nav_button-width: 1.75rem;
}

:global(.rdp-day) {
  @apply rounded-sm;
}
:global(button.rdp-selected) {
  @apply bg-primary-500;
}

:global(.rdp-month_caption) {
  @apply text-base;
  @apply capitalize;
  @apply font-normal;
  @apply text-emphasis-high;
  @apply ml-3;
}

.label {
  @apply block;
  @apply relative;
  @apply w-full;
  @apply bg-transparent;
  @apply min-w-32;
}

:global(.rdp-selected .rdp-day_button) {
  @apply bg-primary-100;
}

:global(.rdp-today) {
  @apply font-bold;
}
